import styled from 'styled-components'

import { HeaderWrapper } from '../../../../../components/GamesCategoryGrid/styled/HeaderWrapper'
import { media } from '../../../../../utils/style-utils'

export const StyledHeaderWrapper = styled(HeaderWrapper)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.3rem 0.5rem 1rem;

  ${media.xs`
    flex-flow: column;
    justify-content: flex-end;
  `}
`
